Pluswerk.PlusProject.Content = Pluswerk.PlusProject.Content || {};

Pluswerk.PlusProject.Content.HeaderImageIEController = function () {
    if ($("html").hasClass("internet-explorer")) {
        dynamicHeight();
        $(window).on('resize', dynamicHeight);

        function dynamicHeight() {
            var screenHeight = $(window).height();
            if (screenHeight > 766) {
                $(".internet-explorer :not(.header--noImage).header--flex").css('display', 'flex');
            } else {
                $(".internet-explorer :not(.header--noImage).header--flex").css('display', 'inline');
            }
        }
    }
}
